import styled from '@emotion/styled'
import { Icon, Theme } from '@yuno/design-system-web'
import { useTranslation } from 'react-i18next'

type StyledProps = { theme?: Theme }

const Wrapper = styled('div')<StyledProps>`
  width: 100%;
  text-align: center;
  margin: 47px;
`

const Title = styled('p')<StyledProps>`
  font-size: ${({ theme }) => theme.typography.small.regular.fontSize};
  font-weight: ${({ theme }) => theme.typography.small.regular.fontWeight};
  font-family: ${({ theme }) => theme.typography.small.regular.fontFamily};
`

const SubTitle = styled('p')<StyledProps>`
  font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
  font-weight: ${({ theme }) => theme.typography.tiny.regular.fontWeight};
  font-family: ${({ theme }) => theme.typography.tiny.regular.fontFamily};
  color: ${({ theme }) => theme.palette.grey[5]};
`

export const ConnectionCardError = () => {
  const { t } = useTranslation()
  return (
    <Wrapper>
      <Icon name="LinkBreak" size="27" />
      <Title>{t('somethingWentWrong')}</Title>
      <SubTitle>{t('hadProblem')}</SubTitle>
    </Wrapper>
  )
}
